import React from 'react';
export function Footer() {
  return <footer className="bg-navy-950 pb-28 pt-8 text-center sm:pb-12" data-id="element-153" data-mp="19j53j40hsmi0">
      <div className="mx-auto w-full max-w-2xl px-4" data-id="element-154" data-mp="206j2vgr4o7dc">
        <p className="font-display text-lg font-bold text-white" data-id="element-155" data-mp="209x42lo22aj7">Mechanics Decision Map™</p>
        <p className="mt-2 text-[13px] text-white/50" data-id="element-156" data-mp="2f2quv38s2d36">© 2026 · Dr. Karito · All rights reserved.</p>
        <p className="mx-auto mt-4 max-w-lg text-[12px] leading-relaxed text-white/40" data-id="element-157" data-mp="2a3w5figb1qa3">
          This material is an educational and clinical planning resource. It does not replace formal
          education, clinical supervision, professional judgment, or patient-specific treatment protocols.
        </p>
      </div>
    </footer>;
}